var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{staticClass:"lender-list pros",attrs:{"background":"lblue","width":"lg"}},[_c('ul',{staticClass:"list"},_vm._l((_vm.lenderIds),function(lenderId,index){return _c('ListItem',{key:index,attrs:{"id":lenderId}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }